import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      {/* Main Footer */}
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold mb-6">BLUSH & GO</h3>
            <p className="text-neutral-400 text-sm leading-relaxed mb-6">
              Curated beauty essentials for the modern woman. Discover top-rated products from trusted brands.
            </p>
            <div className="flex gap-4">
              <a href="#" className="p-2 border border-neutral-700 hover:border-white transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 border border-neutral-700 hover:border-white transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 border border-neutral-700 hover:border-white transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-6">Shop</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/category/skincare" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Skincare
                </Link>
              </li>
              <li>
                <Link to="/category/makeup" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Makeup
                </Link>
              </li>
              <li>
                <Link to="/category/haircare" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Haircare
                </Link>
              </li>
              <li>
                <Link to="/category/fragrance" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Fragrance
                </Link>
              </li>
              <li>
                <Link to="/category/bath-body" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Bath & Body
                </Link>
              </li>
              <li>
                <Link to="/category/tools" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Tools & Brushes
                </Link>
              </li>
            </ul>
          </div>

          {/* Help Column */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-6">Help</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Shipping Info
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-400 hover:text-white text-sm transition-colors">
                  Returns
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-6">Stay Connected</h4>
            <p className="text-neutral-400 text-sm mb-4">
              Subscribe for exclusive offers and beauty tips.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-transparent border border-neutral-700 border-r-0 px-4 py-3 text-sm focus:outline-none focus:border-white transition-colors"
                data-testid="footer-email-input"
              />
              <button 
                className="px-4 border border-neutral-700 hover:bg-white hover:text-black transition-colors"
                data-testid="footer-subscribe-btn"
              >
                <Mail className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-neutral-800">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-neutral-500 text-xs">
              © {currentYear} Blush & Go. All rights reserved.
            </p>
            <p className="text-neutral-500 text-xs">
              As an Amazon Associate, we earn from qualifying purchases.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-neutral-500 hover:text-white text-xs transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-neutral-500 hover:text-white text-xs transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
